
import Home from '../../Assets/svg/home.svg'
import About from '../../Assets/svg/about.svg'
import Tech from '../../Assets/svg/tech.svg'
import Faq from '../../Assets/svg/faq.svg'
import Swap from '../../Assets/svg/swap.svg'

import AboutWhite from '../../Assets/svg/about_white.svg'
import TechWhite from '../../Assets/svg/tech_white.svg'
import FaqWhite from '../../Assets/svg/faq_white.svg'
import SwapWhite from '../../Assets/svg/swap_white.svg'

export const SideBarList = [
    // {
    //     name: "Home",
    //     url: "/",
    //     img:Home
    // },
    {
        name: "Bridge",
        url: "/",
        img: Swap
    },
    // {
    //     name: "Manual",
    //     url: "/Manual",
    //     img: About
    // },
    // {
    //     name: "Language",
    //     url: "/Language",
    //     img: Faq
    // },
    {
        name: "History",
        url: "/TransactionHistory",
        img: Tech
    },
    {
        name: "Status",
        url: "/Status",
        img: Tech
    }
]

export const SideBarListDark = [
    // {
    //     name: "Home",
    //     url: "/",
    //     img:Home
    // },
    {
        name: "Bridge",
        url: "/",
        img: SwapWhite
    },

    {
        name: "Manual",
        url: "/Manual",
        img: AboutWhite
    },
    {
        name: "History",
        url: "/TransactionHistory",
        img: TechWhite
    },
    // {
    //     name: "Language",
    //     url: "/Language",
    //     img: FaqWhite
    // },
    {
        name: "Status",
        url: "/Status",
        img: TechWhite
    }
]